<script setup lang="ts">
import { ref, computed } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { useUserStore } from '@/stores/user'
import { useVoiceStore } from '@/stores/voice'
import { Card } from '@/components/ui/card'
import VoiceChat from './VoiceChat.vue'
import VoiceIndicator from './VoiceIndicator.vue'

const userStore = useUserStore()
const voiceStore = useVoiceStore()
const isAdmin = computed(() => userStore.isAdmin)
const isVoiceActive = computed(() => voiceStore.isConnected)

const isExpanded = ref(false)
const chatContainer = ref(null)

function expand() {
  isExpanded.value = true
}

function collapse() {
  isExpanded.value = false
}

onClickOutside(chatContainer, () => {
  if (isExpanded.value) {
    collapse()
  }
})
</script>

<template>
  <div v-if="isAdmin" class="fixed bottom-6 left-6 z-50">
    <!-- Expanded State -->
    <div
      v-show="isExpanded"
      ref="chatContainer"
      class="w-[440px] h-[600px] transition-opacity duration-300"
      :class="{ 'opacity-100': isExpanded, 'opacity-0': !isExpanded }"
    >
      <Card class="w-full h-full flex flex-col shadow-2xl rounded-xl overflow-hidden">
        <VoiceChat @close="collapse" />
      </Card>
    </div>

    <!-- Collapsed State -->
    <div v-show="!isExpanded" class="relative" @click="expand">
      <VoiceIndicator />
      <!-- Context Tracking Indicator -->
      <div
        v-if="isVoiceActive"
        class="absolute -top-2 -right-2 w-3 h-3 bg-green-500 rounded-full animate-pulse"
        title="Context tracking active"
      />
    </div>
  </div>
</template>

<style scoped>
/* We can remove the fade transitions as v-show with opacity handles it */
</style>
